// File: src/routes/index.tsx
import type { ReactElement } from 'react';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
import PrivateRoute from '../utils/PrivateRoute';
import { activityRoutes } from './activity.routes';
import { adminRoutes } from './admin.routes';
import { billingRoutes } from './billing.routes';
import { locationsRoutes } from './locations.routes';
import { menusRoutes } from './menus.routes';
import { ordersRoutes } from './orders.routes';
import type { AppRoute } from './types';

const all: AppRoute[] = [
    ...ordersRoutes,
    ...menusRoutes,
    ...locationsRoutes,
    ...activityRoutes,
    ...billingRoutes,
    ...adminRoutes,
];

const publicRoutes = all.filter((r) => r.handle?.public);
const standaloneRoutes = all.filter((r) => r.handle?.standalone);
const shellRoutes = all.filter((r) => !r.handle?.public && !r.handle?.standalone);

const AppRoutes = () =>
    useRoutes([
        ...publicRoutes,
        ...standaloneRoutes.map((r) => ({ ...r, element: <PrivateRoute>{r.element as ReactElement}</PrivateRoute> })),
        {
            path: '/',
            element: (
                <PrivateRoute>
                    <Layout />
                </PrivateRoute>
            ),
            children: shellRoutes,
        },
    ]);

const Routing = () => (
    <BrowserRouter>
        <AppRoutes />
    </BrowserRouter>
);

export default Routing;
